import filterFunction from './filterFunction'
import toggleSelectByGroup from './toggleSelectByGroup'

export default {
  filterFunction,
  toggleSelectByGroup,
}
